export const WHATSAPP_ERRO_ENTREGA_MESSAGE_ACCOUNT_RESTRICTION = "463"

const C_TEXTO_RESTRICAO_CONTA = "O WhatsApp impediu o envio desta mensagem"

/**
 * Extrai metadado certtus.erroEntrega do dataJson (string ou objeto).
 * @param {string|object|null|undefined} dataJson
 * @returns {{ codigo: string, tipo?: string }|null}
 */
export function mensagemErroEntregaExtrair(dataJson) {
  if (!dataJson) return null

  try {
    const oParsed = typeof dataJson === "string" ? JSON.parse(dataJson) : dataJson
    const oErro = oParsed?.certtus?.erroEntrega
    if (!oErro?.codigo) return null
    return { codigo: String(oErro.codigo), tipo: oErro.tipo ? String(oErro.tipo) : undefined }
  } catch {
    return null
  }
}

/**
 * Deriva aviso específico de falha de entrega (ex.: erro 463).
 * @param {Object} oParams
 * @param {boolean} oParams.fromMe
 * @param {string|object|null} [oParams.dataJson]
 * @param {string} [oParams.erroEntregaCodigo]
 * @returns {{ exibir: boolean, texto: string|null }}
 */
export default function mensagemErroEntregaDerivar({ fromMe, dataJson, erroEntregaCodigo }) {
  if (!fromMe) return { exibir: false, texto: null }

  const cCodigo = erroEntregaCodigo || mensagemErroEntregaExtrair(dataJson)?.codigo
  if (!cCodigo) return { exibir: false, texto: null }

  if (cCodigo === WHATSAPP_ERRO_ENTREGA_MESSAGE_ACCOUNT_RESTRICTION) {
    return { exibir: true, texto: C_TEXTO_RESTRICAO_CONTA }
  }

  return { exibir: false, texto: null }
}
